import Image from "next/image";
import { useState, useEffect } from "react";

interface ProductImageProps {
  src: string;
  alt: string;
  className?: string;
}

const ProductImage = ({ src, alt, className }: ProductImageProps) => {
  const [imgSrc, setImgSrc] = useState(src);

  useEffect(() => {
    setImgSrc(src);
  }, [src]);

  const handleImageError = () => {
    setImgSrc("/img/No_Image.jpg");
  };

  return (
    <Image
      src={imgSrc}
      alt={alt}
      fill
      sizes="80px"
      onError={handleImageError}
      className={className}
    />
  );
};

export default ProductImage;
